export default __webpack_public_path__ + "static/media/img3_1.324e4e7d.jpg";